import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { changePassword } from '../services/api';
import '../styles/AuthPage.css';

function ChangePasswordPage() {
  const [form, setForm] = useState({ current: '', next: '', confirm: '' });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [done, setDone] = useState(false);
  const navigate = useNavigate();

  const set = (field) => (e) => setForm((f) => ({ ...f, [field]: e.target.value }));

  const handleSubmit = async (e) => {
    e.preventDefault();
    const { current, next, confirm } = form;

    if (!current || !next) {
      setError('Please fill in both password fields');
      return;
    }
    if (next.length < 8) {
      setError('New password must be at least 8 characters');
      return;
    }
    if (next !== confirm) {
      setError('New passwords do not match');
      return;
    }

    setLoading(true);
    setError('');
    try {
      await changePassword(current, next);
      setDone(true);
    } catch (err) {
      setError(err.response?.data?.error || 'Could not change your password. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  if (done) {
    return (
      <div className="auth-container">
        <div className="auth-box">
          <h1>PaperBuddy</h1>
          <p className="auth-subtitle">Your password has been changed.</p>
          <button type="button" className="auth-btn" onClick={() => navigate('/papers')}>
            Back to papers
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className="auth-container">
      <div className="auth-box">
        <h1>PaperBuddy</h1>
        <p className="auth-subtitle">Change your password</p>

        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label htmlFor="current">Current password</label>
            <input
              id="current"
              type="password"
              value={form.current}
              onChange={set('current')}
              disabled={loading}
              autoFocus
              autoComplete="current-password"
            />
          </div>

          <div className="form-group">
            <label htmlFor="next">New password</label>
            <input
              id="next"
              type="password"
              value={form.next}
              onChange={set('next')}
              placeholder="At least 8 characters"
              disabled={loading}
              autoComplete="new-password"
            />
          </div>

          <div className="form-group">
            <label htmlFor="confirm">Confirm new password</label>
            <input
              id="confirm"
              type="password"
              value={form.confirm}
              onChange={set('confirm')}
              disabled={loading}
              autoComplete="new-password"
            />
          </div>

          {error && <div className="auth-error">{error}</div>}

          <button type="submit" className="auth-btn" disabled={loading}>
            {loading ? 'Saving…' : 'Change password'}
          </button>
        </form>

        <div className="auth-links">
          <Link to="/papers" className="auth-link">Cancel</Link>
        </div>
      </div>
    </div>
  );
}

export default ChangePasswordPage;
